import React           from 'react';
import PropTypes       from 'prop-types';

import Translations    from '../../../utils/Translations';
import { generateKey } from '../../../utils/CommonUtils';

const AboutMeCharacter = (props) => {

    const title = props?.isCouple 
        ? Translations.get('actor_profile.about_me-facts.couple-partner') 
        : Translations.get('actor_profile.about_me-facts.character');

    const biasTitle = <h3 className="content-box__body__headline">{title}</h3>;

    const characteristics = props?.characteristics?.map((characteristic, index) => {
        let alignClass = "-center";
        if(characteristic.attribute1 === characteristic.value) {
            alignClass = "-left";
        } else if(characteristic.attribute2 === characteristic.value) {
            alignClass = "-right";
        }
        return (
            <div 
                key={generateKey('actor-bias', index)}
                className="actor-bias"
            >
                <div className="actor-bias__box">
                    <div className={`actor-bias__box__highlight ${alignClass}`} />
                    <span className="actor-bias__box__text">{characteristic.attribute1}</span>
                    <span className="actor-bias__box__text -right">{characteristic.attribute2}</span>
                </div>
            </div>
        );
    });
    
    return (
        <div className="about-me_my-profile_my-character">
            {biasTitle}
            <div className='about-me_my-profile_my-character_characteristics'>
                {characteristics}
            </div>
        </div>
    );
};

AboutMeCharacter.propTypes = {
    characteristics: PropTypes.arrayOf(PropTypes.shape({
        attribute1:    PropTypes.string,
        attributeKey1: PropTypes.number,
        attribute2:    PropTypes.string,
        attribute2Key: PropTypes.number,
        value:         PropTypes.string
    })),
    isCouple: PropTypes.bool,
    partnerCupSize: PropTypes.string
};

export default AboutMeCharacter;